export enum AppPermissions {
  ORDER_DELIVERY,
  CAN_USE_CREDIT_CARD,
}
